
import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';


export const getCompanyNews = {
  
  ...crudFactory(API_ENDPOINTS.FORUM),
  get:({ 
    tag,
    ...params 
  }) => {    
    return HttpClientFront.get(`news_by_symbol/${tag}`, {
      ...params,      
    });
  },
  home:() => {    
    return HttpClientFront.get(`get_home_page_news`);
  },
};

